/**
 * Directive: formsCheckbox
 */
angular.module('acme.common.directive.forms.checkbox', [])
.directive('formsCheckbox', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/forms/checkbox/checkbox.tpl.html',
      scope: {
        model: '=',
        label: '=',
        value: '=',
        validTest: '=',
        id: '@',
        name: '@',
        errorMessage: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.formsCheckbox = {

          checked: false,

          init: function() {
            $scope.$on('$destroy', $scope.$watch('model', function (n, o) {
              $scope.formsCheckbox.checked = (n); // Intentional type coersion
            }));
          }

        };

        $scope.formsCheckbox.init();

      }]

    };

}]);